module.exports = __webpack_public_path__ + "img/notification.df2b8252.png";